"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Accordion = _interopRequireDefault(require("react-bootstrap/Accordion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Collapse container with indicator, text label and content.
 *
 * # Variants
 *
 * ## Basic
 *
 * Basic collapse is an example of a Collapse component, with a Collapse.Group,
 * and a single entry in the group. A single Collapse.Group entry consists of a
 * Collapse.Toggle and a Collapse.Collapse. They are related to each other via
 * the `eventKey` prop.
 */
const Collapse = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, props, children);
};
Collapse.propTypes = {
  children: function (props, propName, componentName) {
    let invalidProp = false;
    if (props[propName] instanceof Array) {
      props[propName].map(item => {
        if (item.type !== CollapseGroup) {
          invalidProp = true;
        }
      });
    } else if (props[propName].type !== CollapseGroup) {
      invalidProp = true;
    }
    if (invalidProp) {
      return new Error(`Invalid prop "${propName}" supplied to "${componentName}", expected "Collapse.Group". Validation failed.`);
    }
  }
};
const CollapseToggle = _ref2 => {
  let {
    children,
    onClick,
    open,
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Accordion.default.Toggle, _extends({
    className: "btn-collapse",
    onClick: onClick,
    "aria-expanded": open ? true : false
  }, props), children, /*#__PURE__*/_react.default.createElement("span", {
    className: "indicator"
  }));
};
CollapseToggle.displayName = 'Collapse.Toggle';
CollapseToggle.propTypes = {
  children: _propTypes.default.node.isRequired,
  eventKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  open: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
const CollapseCollapse = _ref3 => {
  let {
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_Accordion.default.Collapse, props, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, children));
};
CollapseCollapse.displayName = 'Collapse.Collapse';
CollapseCollapse.propTypes = {
  children: _propTypes.default.node.isRequired,
  eventKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
const CollapseGroup = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-collapse"
  }, children);
};
CollapseGroup.displayName = 'Collapse.Group';
CollapseGroup.propTypes = {
  children: _propTypes.default.node.isRequired
};
Collapse.Toggle = CollapseToggle;
Collapse.Collapse = CollapseCollapse;
Collapse.Group = CollapseGroup;
var _default = exports.default = Collapse;